import { connect } from 'react-redux';
import { HierarchyReportingAccess } from '../../components/reporting/HierarchyReportingAccess';
import { DistributionType } from '../../models';
import { IApplicationState } from '../../store';
import { ActionCreators as HierarchyReportingActionCreators } from '../../store/HierarchyReportingAccessStore';
import { ActionCreators as ReportingProfileActionCreators } from '../../store/ReportingProfileStore';

export const HierarchyReportingAccessContainer: React.ComponentType<{
	distributionType: DistributionType;
	surveyId: number;
	isSurveyAdmin?: boolean;
}> = connect(
	(state: IApplicationState) => {
		return {
			...state.hierarchyReportingAccess,
			reportingProfileConfigs: state.reportingProfile.reportingProfileConfigs,
		};
	},
	{
		...HierarchyReportingActionCreators,
		InitializeReportingProfileState: ReportingProfileActionCreators.InitializeState,
	},
)(HierarchyReportingAccess);
